module.exports = __webpack_public_path__ + "media/images/logo-17638e8f4073d2e1462fe2d139a8a9ad.svg";